// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var DashboardCardComponents__Tw = require("./DashboardCardComponents__Tw.bs.js");
var ChapterDashboardChapterMembers_agent_graphql = require("../../__generated__/ChapterDashboardChapterMembers_agent_graphql.bs.js");
var ChapterDashboardChapterMembers_query_graphql = require("../../__generated__/ChapterDashboardChapterMembers_query_graphql.bs.js");

function ChapterDashboard__ChapterMembers$CardBodyContainer(props) {
  var __show_footer = props.show_footer;
  var show_footer = __show_footer !== undefined ? __show_footer : true;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                props.children,
                show_footer ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(DashboardCardComponents__Tw.Footer.make, {
                              href: "/members",
                              linkText: "View all members"
                            }),
                        className: "mt-8"
                      }) : null
              ]
            });
}

var CardBodyContainer = {
  make: ChapterDashboard__ChapterMembers$CardBodyContainer
};

function ChapterDashboard__ChapterMembers$LoadingState(props) {
  return JsxRuntime.jsx(ChapterDashboard__ChapterMembers$CardBodyContainer, {
              show_footer: false,
              children: JsxRuntime.jsx(DashboardCardComponents__Tw.LoadingStateContainer.make, {
                    children: JsxRuntime.jsx(Loader.make, {})
                  })
            });
}

var LoadingState = {
  make: ChapterDashboard__ChapterMembers$LoadingState
};

var convertFragment = ChapterDashboardChapterMembers_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardChapterMembers_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardChapterMembers_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ChapterDashboardChapterMembers_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardChapterMembers_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ChapterDashboard__ChapterMembers$SingleItem(props) {
  var agent = use(props.agent);
  var match = agent.profilePhoto;
  return JsxRuntime.jsx(ButtonsV5.Link.make, {
              href: "/agents/" + agent.id,
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: match !== undefined ? JsxRuntime.jsx("img", {
                                        className: "w-24 h-24 rounded-full mx-auto",
                                        src: match.url
                                      }) : JsxRuntime.jsx("div", {
                                        children: Core__Option.getOr(agent.firstName, "").slice(0, 1) + Core__Option.getOr(agent.lastName, "").slice(0, 1),
                                        className: "w-24 h-24 rounded-full bg-slate-100 text-slate-500 text-2xl uppercase font-semibold flex justify-center items-center mx-auto"
                                      })
                              }),
                          JsxRuntime.jsx("div", {
                                children: agent.displayName,
                                className: "mt-2 text-gray-900 font-medium"
                              })
                        ]
                      }))
            });
}

var SingleItem = {
  AgentFragment: AgentFragment,
  make: ChapterDashboard__ChapterMembers$SingleItem
};

var convertFragment$1 = ChapterDashboardChapterMembers_query_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardChapterMembers_query_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardChapterMembers_query_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ChapterDashboardChapterMembers_query_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardChapterMembers_query_graphql.node, convertFragment$1, fRef);
}

var QueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ChapterDashboard__ChapterMembers(props) {
  var query = use$1(props.query);
  var match = query.currentChapterV5;
  if (match === undefined) {
    return JsxRuntime.jsx(ErrorComponent.make, {
                message: "Something went wrong."
              });
  }
  var members = Core__Array.filterMap(match.members.edges, (function (e) {
          if (e !== undefined) {
            return e.node;
          }
          
        }));
  return JsxRuntime.jsxs(ChapterDashboard__ChapterMembers$CardBodyContainer, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: "There are " + (match.memberCount.toString() + (" Top Agent Network members in " + match.displayName)),
                            className: "text-gray-500"
                          }),
                      className: "mb-6"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: "Newest members",
                              className: "font-medium text-lg"
                            }),
                        JsxRuntime.jsx("ul", {
                              children: members.map(function (agent) {
                                    return JsxRuntime.jsx("li", {
                                                children: JsxRuntime.jsx(ChapterDashboard__ChapterMembers$SingleItem, {
                                                      agent: agent.fragmentRefs
                                                    }),
                                                className: "w-24 text-center"
                                              }, agent.id);
                                  }),
                              className: "flex flex-row items-start flex-wrap text-gray-900 mt-6 gap-4"
                            })
                      ]
                    })
              ]
            });
}

var DashboardCardComponents;

var make = ChapterDashboard__ChapterMembers;

exports.DashboardCardComponents = DashboardCardComponents;
exports.CardBodyContainer = CardBodyContainer;
exports.LoadingState = LoadingState;
exports.SingleItem = SingleItem;
exports.QueryFragment = QueryFragment;
exports.make = make;
/* Loader Not a pure module */
